import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

/**
 * 更新用户信息函数
 * @param {string} token 用户的 JWT Token
 * @param {Object} userData 用户信息
 * @param {string} userData.username 用户名
 * @param {string} userData.email 邮箱（可选）
 * @param {string} userData.birthday 生日（可选，格式：YYYY-MM-DD）
 * @param {string} userData.birthplace 出生地（可选）
 * @param {string} userData.birthtime 出生时间（可选，格式：HH:mm:ss）
 * @param {string} userData.former_password 旧密码（更新密码时需要）
 * @param {string} userData.password 新密码（可选）
 * @returns {Promise<Object>} 返回后端的响应数据
 */
export const updateUserInfo = async (
  token: string,
  userData: {
    username: string;
    email?: string;
    birthday?: string;
    birthplace?: string;
    birthtime?: string;
    former_password?: string;
    password?: string;
  }
): Promise<any> => {
  try {
    const apiBaseUrl = getApiBaseUrl();

    const response = await axios.post(
      `${apiBaseUrl}/updateUserInfo`,
      userData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data; // 返回后端响应数据
  } catch (err: any) {
    console.error('更新用户信息失败:', err.message);
    if (err.response?.data?.error) {
      throw new Error(err.response.data.error);
    }
    throw new Error('更新用户信息失败，请检查输入或网络连接');
  }
};

